import React, { ContextType, useCallback, useMemo, useState } from 'react'

import { ReplyToMessageContext } from './ReplyToMessageContext'

export const ReplyContextProvider = (props: {
    children: React.ReactNode
    canReplyInline: boolean
    canReplyInThread: boolean
}) => {
    const { children, canReplyInline, canReplyInThread } = props
    const [replyMode, setReplyMode] = useState<'inline' | 'thread'>('inline')
    const [replyToEventId, setReplyToThreadId] = useState<string | null>(null)

    const setReplyToEventId = useCallback((threadId: string | null) => {
        setReplyToThreadId(threadId)
    }, [])

    const onSetReplyMode = useCallback(
        (mode: 'inline' | 'thread') => {
            if (mode === 'thread' && !canReplyInThread) {
                return
            }
            if (mode === 'inline' && !canReplyInline) {
                return
            }
            setReplyMode(mode)
        },
        [canReplyInThread, canReplyInline],
    )

    const onResetContext = useCallback(() => {
        setReplyMode('inline')
        setReplyToThreadId(null)
    }, [])

    const value = useMemo<ContextType<typeof ReplyToMessageContext>>(
        () => ({
            canReplyInline,
            canReplyInThread,
            setReplyToEventId,
            replyToEventId,
            replyMode,
            setReplyMode: onSetReplyMode,
            resetReplyToMessageContext: onResetContext,
        }),
        [
            canReplyInline,
            canReplyInThread,
            setReplyToEventId,
            replyToEventId,
            replyMode,
            onSetReplyMode,
            onResetContext,
        ],
    )

    return <ReplyToMessageContext.Provider value={value}>{children}</ReplyToMessageContext.Provider>
}
